import { useQuery } from "@tanstack/react-query";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { api, tl } from "@/lib/api";

export default function Account() {
  const { user, ready } = useAuth();
  const { data: orders = [] } = useQuery({ queryKey: ["my-orders"], queryFn: () => api.get("/orders/mine").then((r) => r.data), enabled: !!user });
  if (ready && !user) return <Navigate to="/giris?next=/hesabim" replace />;
  return (
    <div className="max-w-4xl mx-auto px-4 py-10">
      <h1 className="text-3xl font-bold text-[#172554]">Merhaba, {user?.name}</h1>
      <p className="text-slate-600 text-sm mt-1">{user?.email} · {user?.phone}</p>
      <h2 className="text-lg font-bold mt-8 mb-3">Siparişlerim</h2>
      {!orders.length && <div className="bg-white border rounded-lg p-8 text-center text-slate-500" data-testid="account-no-orders">Henüz siparişiniz yok.</div>}
      <div className="space-y-3">
        {orders.map((o) => (
          <div key={o.id} data-testid={`account-order-${o.order_no}`} className="bg-white border rounded-lg p-4 flex flex-wrap gap-3 justify-between">
            <div>
              <div className="font-mono font-bold">{o.order_no}</div>
              <div className="text-xs text-slate-500">{new Date(o.created_at).toLocaleString("tr-TR")} · {o.cargo}{o.tracking_no ? ` · Takip: ${o.tracking_no}` : ""}</div>
              <div className="text-sm mt-1">{o.items.map((i) => `${i.qty}x ${i.name}`).join(", ")}</div>
            </div>
            <div className="text-right">
              <div className="font-extrabold text-[#172554]">{tl(o.total)}</div>
              <span className="text-xs font-semibold px-2 py-0.5 rounded bg-blue-50 text-[#172554]">{o.status}</span>
              <span className="ml-1 text-xs font-semibold px-2 py-0.5 rounded bg-slate-100">{o.payment_status}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
